export default __webpack_public_path__ + "static/media/ask3.f3c22091.svg";